/**
 * @generated SignedSource<<dd11d199dd050c222972de5586bfa662>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastChangedSubscription$variables = {
  storecastId: string;
};
export type StorecastChangedSubscription$data = {
  readonly storecastChanged: {
    readonly id: string;
    readonly name: string;
    readonly widgets: ReadonlyArray<{
      readonly __typename: string;
      readonly id: string;
      readonly note?: {
        readonly " $fragmentSpreads": FragmentRefs<"NoteEdit" | "NoteEditSharedInfo_widgetNote">;
      };
      readonly " $fragmentSpreads": FragmentRefs<"AllWidgets_widget" | "InteractiveWidgetWrapper_widget" | "useWidgetToPos_widget">;
    } | null>;
  };
};
export type StorecastChangedSubscription = {
  response: StorecastChangedSubscription$data;
  variables: StorecastChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "storecastId",
    "variableName": "storecastId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionX",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionY",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "overviewSize",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noteSize",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "editingMode",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrgNote",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v15 = {
  "alias": "largeImage",
  "args": [
    {
      "kind": "Literal",
      "name": "minHeight",
      "value": 1080
    },
    {
      "kind": "Literal",
      "name": "minWidth",
      "value": 1080
    }
  ],
  "concreteType": "ImageSize",
  "kind": "LinkedField",
  "name": "size",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": "size(minHeight:1080,minWidth:1080)"
},
v16 = [
  (v12/*: any*/),
  (v2/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fontColor",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includedInSlideshow",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundColor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentValue",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fontSize",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fontStyle",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageScale",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageTranslateX",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageTranslateY",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteImageURL",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containImage",
  "storageKey": null
},
v29 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "thumbhash",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "sizes",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlExpiresAt",
        "storageKey": null
      },
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "storageKey": null
  }
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v29/*: any*/),
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgIconUri",
  "storageKey": null
},
v33 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/),
    (v2/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v38 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freq",
  "storageKey": null
},
v42 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  }
],
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberValue",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sectionId",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkValue",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "condition",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "WidgetFileEdge",
  "kind": "LinkedField",
  "name": "files",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v54/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FilePage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": (v29/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slideshowDuration",
  "storageKey": null
},
v57 = [
  (v2/*: any*/),
  (v15/*: any*/)
],
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v59 = [
  {
    "kind": "Literal",
    "name": "includeInlineRoutines",
    "value": true
  }
],
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v51/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "minHeight",
              "value": 120
            },
            {
              "kind": "Literal",
              "name": "minWidth",
              "value": 120
            }
          ],
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": (v16/*: any*/),
          "storageKey": "size(minHeight:120,minWidth:120)"
        }
      ],
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    (v32/*: any*/)
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineAt",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueCount",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedEmployee",
  "kind": "LinkedField",
  "name": "assigned",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v64/*: any*/),
        (v30/*: any*/),
        (v31/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v66 = [
  (v2/*: any*/)
],
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedRole",
  "kind": "LinkedField",
  "name": "assignedRoles",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeRole",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v64/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employeeIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "team",
          "plural": false,
          "selections": (v66/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employees",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v64/*: any*/),
            (v31/*: any*/),
            (v30/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "myRole",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v70 = [
  (v2/*: any*/),
  (v58/*: any*/),
  (v41/*: any*/),
  {
    "alias": null,
    "args": (v59/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v43/*: any*/),
      {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isTeamScheduleEventOccasion"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v60/*: any*/),
          (v61/*: any*/),
          (v45/*: any*/),
          (v62/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expireAt",
            "storageKey": null
          },
          (v63/*: any*/),
          (v65/*: any*/),
          (v67/*: any*/),
          (v68/*: any*/)
        ],
        "type": "RoutineOccasion",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskExecutionCheck",
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              (v60/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "routineOccasion",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  (v45/*: any*/),
                  (v2/*: any*/),
                  (v69/*: any*/),
                  (v43/*: any*/),
                  (v65/*: any*/),
                  (v67/*: any*/),
                  (v63/*: any*/),
                  (v62/*: any*/),
                  (v4/*: any*/),
                  (v68/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskCheck",
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": (v66/*: any*/),
                "storageKey": null
              },
              (v47/*: any*/),
              (v49/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "TeamScheduleInlineRoutineOccasion",
        "abstractKey": null
      }
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  }
],
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamSchedule",
  "kind": "LinkedField",
  "name": "dailyTeamSchedule",
  "plural": false,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v72 = [
  (v2/*: any*/),
  (v41/*: any*/),
  (v58/*: any*/),
  {
    "alias": null,
    "args": (v59/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v2/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v62/*: any*/),
          (v68/*: any*/)
        ],
        "type": "RoutineOccasion",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskExecutionCheck",
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "routineOccasion",
                "plural": false,
                "selections": [
                  (v62/*: any*/),
                  (v4/*: any*/),
                  (v68/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "TeamScheduleInlineRoutineOccasion",
        "abstractKey": null
      }
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  }
],
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": (v66/*: any*/),
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedStartAtTime",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedEndAtTime",
  "storageKey": null
},
v77 = [
  (v7/*: any*/),
  (v36/*: any*/),
  (v2/*: any*/)
],
v78 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v79 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
  }
],
v80 = [
  (v2/*: any*/),
  (v7/*: any*/)
],
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataSource",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v83 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parts",
    "storageKey": null
  }
],
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "changeType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "storecastChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "widgets",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useWidgetToPos_widget"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AllWidgets_widget"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InteractiveWidgetWrapper_widget"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "note",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "NoteEditSharedInfo_widgetNote"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "NoteEdit"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetNote",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "storecastChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "widgets",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isWidget"
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/)
                ],
                "type": "WidgetOverview",
                "abstractKey": "__isWidgetOverview"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "note",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetNotePage",
                        "kind": "LinkedField",
                        "name": "pages",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": "smallImage",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "minHeight",
                                    "value": 100
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "minWidth",
                                    "value": 100
                                  }
                                ],
                                "concreteType": "ImageSize",
                                "kind": "LinkedField",
                                "name": "size",
                                "plural": false,
                                "selections": (v16/*: any*/),
                                "storageKey": "size(minHeight:100,minWidth:100)"
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnzonedDate",
                            "kind": "LinkedField",
                            "name": "updatedAtDate",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isoString",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Date",
                                "abstractKey": "__isDate"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "updatedByActor",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isActor"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoreUser",
                                    "kind": "LinkedField",
                                    "name": "storeUser",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Employee",
                                        "kind": "LinkedField",
                                        "name": "employee",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v30/*: any*/),
                                          (v31/*: any*/),
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "email",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgDescription",
                                            "kind": "LinkedField",
                                            "name": "orgDescription",
                                            "plural": false,
                                            "selections": [
                                              (v32/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "UserActor",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StorecastScreen",
                                    "kind": "LinkedField",
                                    "name": "screen",
                                    "plural": false,
                                    "selections": (v33/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "ScreenActor",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "GroupActor",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "type": "ConnectActor",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "updatedByActorId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v7/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetNote",
                        "kind": "LinkedField",
                        "name": "widgets",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Dashboard",
                            "kind": "LinkedField",
                            "name": "storecast",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isResizable",
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "type": "WidgetNote",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taskSingleSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "grouping",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSectionVersion",
                    "kind": "LinkedField",
                    "name": "activeSectionVersions",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ordinal",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineSection",
                        "kind": "LinkedField",
                        "name": "section",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Team",
                            "kind": "LinkedField",
                            "name": "assignedTeam",
                            "plural": false,
                            "selections": (v38/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "routine",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v39/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v40/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Routine",
                            "kind": "LinkedField",
                            "name": "routine",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Schedule",
                                "kind": "LinkedField",
                                "name": "schedule",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RecurrenceRule",
                                    "kind": "LinkedField",
                                    "name": "rules",
                                    "plural": true,
                                    "selections": [
                                      (v41/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v42/*: any*/),
                            "concreteType": "TaskNumberOccasionConnection",
                            "kind": "LinkedField",
                            "name": "occasions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskNumberOccasionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskNumberOccasion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RoutineOccasion",
                                        "kind": "LinkedField",
                                        "name": "occasion",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v43/*: any*/),
                                          (v44/*: any*/),
                                          (v45/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaskExecutionNumber",
                                        "kind": "LinkedField",
                                        "name": "taskExecutions",
                                        "plural": true,
                                        "selections": [
                                          (v46/*: any*/),
                                          (v47/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaskNumberGoals",
                                            "kind": "LinkedField",
                                            "name": "goals",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "lessThan",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "greaterThan",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v2/*: any*/),
                                          (v48/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "occasions(first:8)"
                          }
                        ],
                        "type": "TaskNumber",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": (v42/*: any*/),
                            "concreteType": "TaskCheckOccasionConnection",
                            "kind": "LinkedField",
                            "name": "occasions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskCheckOccasionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskCheckOccasion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RoutineOccasion",
                                        "kind": "LinkedField",
                                        "name": "occasion",
                                        "plural": false,
                                        "selections": [
                                          (v43/*: any*/),
                                          (v44/*: any*/),
                                          (v2/*: any*/),
                                          (v45/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaskExecutionCheck",
                                        "kind": "LinkedField",
                                        "name": "taskExecutions",
                                        "plural": true,
                                        "selections": [
                                          (v47/*: any*/),
                                          (v49/*: any*/),
                                          (v2/*: any*/),
                                          (v48/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "occasions(first:8)"
                          }
                        ],
                        "type": "TaskCheck",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetTaskSingle",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "size",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetWeatherOccasion",
                    "kind": "LinkedField",
                    "name": "currentOccasion",
                    "plural": false,
                    "selections": [
                      (v50/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "temp",
                        "storageKey": null
                      },
                      (v51/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetWeatherOccasion",
                    "kind": "LinkedField",
                    "name": "occasions",
                    "plural": true,
                    "selections": [
                      (v52/*: any*/),
                      (v50/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lowTemp",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "highTemp",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetWeather",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "turnpikeSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationTurnpike",
                    "kind": "LinkedField",
                    "name": "integration",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegrationTurnpikeSummary",
                        "kind": "LinkedField",
                        "name": "summary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "acceptedTimeAverageInMs",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "accepted",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unanswered",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rejected",
                            "storageKey": null
                          },
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetIntegrationTurnpike",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "subWidgets",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v13/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          (v8/*: any*/),
                          (v55/*: any*/),
                          (v7/*: any*/),
                          (v56/*: any*/)
                        ],
                        "type": "WidgetFile",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Note",
                            "kind": "LinkedField",
                            "name": "note",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WidgetNotePage",
                                "kind": "LinkedField",
                                "name": "pages",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "image",
                                    "plural": false,
                                    "selections": (v57/*: any*/),
                                    "storageKey": null
                                  },
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "WidgetNote",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetSpace",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "teams",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v37/*: any*/),
                      (v36/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetWithTeams",
                "abstractKey": "__isWidgetWithTeams"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmployeeRole",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": (v33/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "WidgetWithRoles",
                "abstractKey": "__isWidgetWithRoles"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "withoutRoleSelected",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "teams",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v36/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v71/*: any*/)
                        ],
                        "type": "WidgetTeamScheduleContentDaily",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamSchedule",
                            "kind": "LinkedField",
                            "name": "weeklyTeamSchedule",
                            "plural": false,
                            "selections": (v70/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "WidgetTeamScheduleContentWeekly",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamSchedule",
                            "kind": "LinkedField",
                            "name": "monthlyTeamSchedule",
                            "plural": false,
                            "selections": (v70/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "WidgetTeamScheduleContentMonthly",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v71/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamSchedule",
                            "kind": "LinkedField",
                            "name": "weeklyTeamSchedule",
                            "plural": false,
                            "selections": (v72/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamSchedule",
                            "kind": "LinkedField",
                            "name": "monthlyTeamSchedule",
                            "plural": false,
                            "selections": (v72/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "WidgetTeamScheduleContentSummary",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetTeamSchedule",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetIntegrationFlourishPraiseLeaderboardItem",
                    "kind": "LinkedField",
                    "name": "flourishTeams",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "praise",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetIntegrationFlourishPraise",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v55/*: any*/),
                  (v56/*: any*/)
                ],
                "type": "WidgetFile",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/),
                  (v73/*: any*/),
                  (v74/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employee",
                    "kind": "LinkedField",
                    "name": "employeesWithShifts",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmployeeShift",
                        "kind": "LinkedField",
                        "name": "shifts",
                        "plural": true,
                        "selections": [
                          (v54/*: any*/),
                          (v2/*: any*/),
                          (v75/*: any*/),
                          (v76/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "durationSeconds",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startAtSecondsFromMidnight",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmployeeScheduleType",
                            "kind": "LinkedField",
                            "name": "scheduleType",
                            "plural": false,
                            "selections": (v77/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmployeeScheduleSecondaryType",
                            "kind": "LinkedField",
                            "name": "secondaryScheduleType",
                            "plural": false,
                            "selections": (v77/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetEmployeeSchedule",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetEmployeeLeaveItem",
                    "kind": "LinkedField",
                    "name": "employeesOnLeave",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Employee",
                        "kind": "LinkedField",
                        "name": "employee",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmployeeShift",
                        "kind": "LinkedField",
                        "name": "shifts",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v75/*: any*/),
                          (v76/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LeaveReason",
                            "kind": "LinkedField",
                            "name": "leaveReason",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "leaveReason",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "leaveCode",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetEmployeeLeave",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": [
                      (v69/*: any*/),
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "integration",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v73/*: any*/)
                ],
                "type": "WidgetTodoOverview",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v73/*: any*/),
                  {
                    "alias": "signalContent",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": (v78/*: any*/),
                            "concreteType": "SignalConnection",
                            "kind": "LinkedField",
                            "name": "signals",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SignalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Signal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "priority",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StoreZonedDate",
                                        "kind": "LinkedField",
                                        "name": "publishedAtDate",
                                        "plural": false,
                                        "selections": (v79/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "employeeReceiverReceiptsCount",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Store",
                                        "kind": "LinkedField",
                                        "name": "store",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "employeeCount",
                                            "storageKey": null
                                          },
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StoreProduct",
                                        "kind": "LinkedField",
                                        "name": "linkedProducts",
                                        "plural": true,
                                        "selections": (v66/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "descriptionImages",
                                        "plural": true,
                                        "selections": (v66/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "descriptionFiles",
                                        "plural": true,
                                        "selections": (v66/*: any*/),
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__id",
                                    "storageKey": null
                                  }
                                ]
                              }
                            ],
                            "storageKey": "signals(first:20)"
                          },
                          {
                            "alias": null,
                            "args": (v78/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "WidgetSignalOverviewContentMedium__signals",
                            "kind": "LinkedHandle",
                            "name": "signals"
                          }
                        ],
                        "type": "WidgetSignalOverviewContentMedium",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetSignalOverview",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "roleContent",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subscriptionKey",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmployeeRole",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "team",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v36/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Employee",
                                "kind": "LinkedField",
                                "name": "employees",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "type": "WidgetEmployeeRoleOverviewContentListMedium",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetEmployeeRoleOverview",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "taskSections",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineSection",
                        "kind": "LinkedField",
                        "name": "section",
                        "plural": false,
                        "selections": (v80/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "task",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v2/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Routine",
                            "kind": "LinkedField",
                            "name": "routine",
                            "plural": false,
                            "selections": (v80/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "inProgressTaskExecution",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isTaskExecution"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineOccasion",
                            "kind": "LinkedField",
                            "name": "routineOccasion",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v49/*: any*/)
                            ],
                            "type": "TaskExecutionCheck",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v46/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "formattedNumberValue",
                                "storageKey": null
                              }
                            ],
                            "type": "TaskExecutionNumber",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textValue",
                                "storageKey": null
                              }
                            ],
                            "type": "TaskExecutionText",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetTaskCollection",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Routine",
                    "kind": "LinkedField",
                    "name": "routines",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "ownerTeam",
                        "plural": false,
                        "selections": (v33/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasion",
                        "kind": "LinkedField",
                        "name": "lastCompletedOccasion",
                        "plural": false,
                        "selections": [
                          (v44/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "percentage",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetRoutinePositivePercentage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": (v80/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoCategoryTeam",
                    "kind": "LinkedField",
                    "name": "teams",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notResolvedCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "team",
                        "plural": false,
                        "selections": (v38/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetTodoSummary",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetIntegrationPushAppyLeaderboardItem",
                    "kind": "LinkedField",
                    "name": "leaderboard",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "goal",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "progress",
                        "storageKey": null
                      },
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetIntegrationPushAppy",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamScheduleOneOffEvent",
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startAtFormatted",
                        "storageKey": null
                      },
                      (v43/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endAtFormatted",
                        "storageKey": null
                      },
                      (v51/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetCalendar",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v81/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetKPITile",
                    "kind": "LinkedField",
                    "name": "tiles",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subtitle",
                        "storageKey": null
                      },
                      (v82/*: any*/),
                      (v40/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetKPITileTrend",
                        "kind": "LinkedField",
                        "name": "trends",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "change",
                            "storageKey": null
                          },
                          (v58/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "compareValue",
                            "storageKey": null
                          },
                          (v39/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "graph",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v58/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v83/*: any*/),
                            "type": "WidgetKPITileGraphBar",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v83/*: any*/),
                            "type": "WidgetKPITileGraphSlider",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "negative",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "positive",
                                "storageKey": null
                              }
                            ],
                            "type": "WidgetKPITileGraphRegions",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WidgetKPITileGraphGaugePart",
                                "kind": "LinkedField",
                                "name": "gaugeParts",
                                "plural": true,
                                "selections": [
                                  (v36/*: any*/),
                                  (v82/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WidgetKPITileGraphGaugeIndicator",
                                "kind": "LinkedField",
                                "name": "indicators",
                                "plural": true,
                                "selections": [
                                  (v39/*: any*/),
                                  (v82/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "WidgetKPITileGraphGauge",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetKPI",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationNewsfeed",
                    "kind": "LinkedField",
                    "name": "newsfeed",
                    "plural": false,
                    "selections": [
                      (v74/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetNewsfeedPost",
                    "kind": "LinkedField",
                    "name": "posts",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": (v57/*: any*/),
                        "storageKey": null
                      },
                      (v52/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetNewsfeed",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v81/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetListSection",
                    "kind": "LinkedField",
                    "name": "sections",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetListItem",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rightText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rightTextSuffix",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "info",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isWidgetListItemInfo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v79/*: any*/),
                                "type": "StoreZonedDate",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "text",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "italic",
                                    "storageKey": null
                                  }
                                ],
                                "type": "WidgetListItemInfoText",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetList",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v81/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetTableSheet",
                    "kind": "LinkedField",
                    "name": "sheets",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetTableColumn",
                        "kind": "LinkedField",
                        "name": "columns",
                        "plural": true,
                        "selections": [
                          (v58/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetTableSection",
                        "kind": "LinkedField",
                        "name": "sections",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetTableRow",
                            "kind": "LinkedField",
                            "name": "headerRow",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WidgetTableCell",
                                "kind": "LinkedField",
                                "name": "cells",
                                "plural": true,
                                "selections": [
                                  (v82/*: any*/),
                                  (v84/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetTableRow",
                            "kind": "LinkedField",
                            "name": "rows",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WidgetTableCell",
                                "kind": "LinkedField",
                                "name": "cells",
                                "plural": true,
                                "selections": [
                                  (v82/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortValue",
                                    "storageKey": null
                                  },
                                  (v84/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WidgetTable",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b05aa672b51512ab599f76f3406d2985",
    "id": null,
    "metadata": {},
    "name": "StorecastChangedSubscription",
    "operationKind": "subscription",
    "text": "subscription StorecastChangedSubscription(\n  $storecastId: ID!\n) {\n  storecastChanged(storecastId: $storecastId) {\n    id\n    name\n    widgets {\n      id\n      __typename\n      ...useWidgetToPos_widget\n      ...AllWidgets_widget\n      ...InteractiveWidgetWrapper_widget\n      ... on WidgetNote {\n        note {\n          ...NoteEditSharedInfo_widgetNote\n          ...NoteEdit\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment AllWidgetsContent_widget on Widget {\n  __isWidget: __typename\n  ... on WidgetSpace {\n    ...WidgetSpace_widgetSpace\n    __typename\n  }\n  ... on WidgetIntegrationFlourishPraise {\n    ...WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise\n    __typename\n  }\n  ... on WidgetFile {\n    ...WidgetFile_widgetFile\n    __typename\n  }\n  ... on WidgetTeamSchedule {\n    ...WidgetTeamSchedule_widget\n    __typename\n  }\n  ... on WidgetEmployeeSchedule {\n    ...WidgetEmployeeSchedule_widgetEmployeeSchedule\n    __typename\n  }\n  ... on WidgetEmployeeLeave {\n    ...WidgetEmployeeLeave_widgetEmployeeLeave\n    __typename\n  }\n  ... on WidgetWeather {\n    ...WidgetWeather_widget\n    __typename\n  }\n  ... on WidgetTodoOverview {\n    ...WidgetTodoOverview_widget\n    __typename\n  }\n  ... on WidgetSignalOverview {\n    ...WidgetSignalOverview_widget\n    __typename\n  }\n  ... on WidgetEmployeeRoleOverview {\n    ...WidgetEmployeeRoleOverview_widget\n    __typename\n  }\n  ... on WidgetNote {\n    ...WidgetNote_widgetNote\n    __typename\n  }\n  ... on WidgetTaskSingle {\n    ...WidgetTaskSingle_widgetTaskSingle\n    __typename\n  }\n  ... on WidgetTaskCollection {\n    ...WidgetTaskCollection_widgetTaskCollection\n    __typename\n  }\n  ... on WidgetRoutineOverview {\n    ...WidgetRoutineOverview_widgetRoutineOverview\n    __typename\n  }\n  ... on WidgetRoutinePositivePercentage {\n    ...WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage\n    __typename\n  }\n  ... on WidgetTodoSummary {\n    ...WidgetTodoSummary_widgetTodoSummary\n    __typename\n  }\n  ... on WidgetCalendarOverview {\n    ...WidgetCalendarOverview_widget\n    __typename\n  }\n  ... on WidgetIntegrationPushAppy {\n    ...WidgetIntegrationPushAppy_widgetIntegrationPushAppy\n    __typename\n  }\n  ... on WidgetIntegrationTurnpike {\n    ...WidgetIntegrationTurnpike_widgetIntegrationTurnpike\n    __typename\n  }\n  ... on WidgetCalendar {\n    ...WidgetCalendar_widgetCalendar\n    __typename\n  }\n  ... on WidgetKPI {\n    ...WidgetKPI_widgetKPI\n    __typename\n  }\n  ... on WidgetNewsfeed {\n    ...WidgetNewsfeed_widgetNewsfeed\n    __typename\n  }\n  ... on WidgetList {\n    ...WidgetList_widgetList\n    __typename\n  }\n  ... on WidgetTable {\n    ...WidgetTable_table\n    __typename\n  }\n}\n\nfragment AllWidgets_widget on Widget {\n  __isWidget: __typename\n  __typename\n  id\n  title\n  ... on WidgetWithTeams {\n    __isWidgetWithTeams: __typename\n    teams {\n      name\n      icon\n      color\n      id\n    }\n  }\n  ... on WidgetWithRoles {\n    __isWidgetWithRoles: __typename\n    roles {\n      name\n      id\n    }\n  }\n  ... on WidgetTeamSchedule {\n    withoutRoleSelected\n  }\n  ...AllWidgetsContent_widget\n}\n\nfragment Avatar_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        ...Avatar_employee\n        id\n      }\n      user {\n        name\n        ...Avatar_user\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    ...Avatar_groupActor\n  }\n  ... on ConnectActor {\n    __typename\n    ...Avatar_connectActor\n  }\n}\n\nfragment Avatar_connectActor on ConnectActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_groupActor on GroupActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment InteractiveWidgetWrapper_widget on Widget {\n  __isWidget: __typename\n  id\n  __typename\n  ... on WidgetNote {\n    isResizable\n  }\n  ...widgetSettingsAvailable_widget\n}\n\nfragment ListItemAssignees_employees on Employee {\n  id\n  ...ListItemEmployees_employees\n}\n\nfragment ListItemAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment ListItemEmployees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ListItemRoles_roles on EmployeeRole {\n  id\n  name\n  isLinkedToViewer\n  employeeIds\n  team {\n    id\n  }\n  employees {\n    id\n    name\n    isLinkedToViewer\n    workStatus\n    ...Avatar_employee\n  }\n}\n\nfragment NewsfeedNative_widgetNewsfeed on WidgetNewsfeed {\n  id\n  title\n  posts {\n    ...WidgetNewsfeedPost_widgetNewsfeedPost\n  }\n}\n\nfragment NewsfeedWeb_widgetNewsfeed on WidgetNewsfeed {\n  posts {\n    ...WidgetNewsfeedPost_widgetNewsfeedPost\n  }\n}\n\nfragment NoteEdit on Note {\n  id\n  ...NoteEditSharedInfo_widgetNote\n  pages {\n    id\n    ...WidgetNoteCameraMode_widgetNotePage\n    ...WidgetNotePageImageMode_widgetNotePage\n    ...NoteEditInfo_page\n    ...WidgetNoteTextModePage_widgetNotePage\n    ...WidgetNoteTextModeAccessoryView_page\n  }\n  noteSize\n}\n\nfragment NoteEditInfo_page on WidgetNotePage {\n  updatedAtDate {\n    ...FormattedDate\n  }\n  updatedByActor {\n    __typename\n    ...SignedActor_actor\n  }\n}\n\nfragment NoteEditSharedInfo_widgetNote on Note {\n  widgets {\n    storecast {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment NoteNative_note on Note {\n  id\n  editingMode\n  isOrgNote\n  title\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment NoteWeb_note on Note {\n  id\n  title\n  isOrgNote\n  noteSize\n  editingMode\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    includedInSlideshow\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment PageSettingsDeleteButton_image on Image {\n  id\n  ...PageSettingsSmallImage_image\n}\n\nfragment PageSettingsLeft_page on WidgetNotePage {\n  id\n  image {\n    id\n    ...PageSettingsDeleteButton_image\n  }\n  ...WidgetNotePageBackgroundSelector_widgetNotePage\n  ...TextControl_widgetNotePage\n}\n\nfragment PageSettingsSmallImage_image on Image {\n  id\n  smallImage: size(minWidth: 100, minHeight: 100) {\n    url\n    id\n  }\n}\n\nfragment PageSettings_page on WidgetNotePage {\n  id\n  image {\n    id\n    ...PageSettingsDeleteButton_image\n  }\n  ...TextControl_widgetNotePage\n  ...WidgetNotePageBackgroundSelector_widgetNotePage\n}\n\nfragment RoutineOccasionStatusCircleInline_RoutineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  deadlineAt\n  startAt\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment SignalOverviewListItemMedium_Signal on Signal {\n  id\n  title\n  priority\n  publishedAtDate {\n    ...StoreFormattedDate\n  }\n  employeeReceiverReceiptsCount\n  store {\n    employeeCount\n    id\n  }\n  linkedProducts {\n    id\n  }\n  descriptionImages {\n    id\n  }\n  descriptionFiles {\n    id\n  }\n}\n\nfragment SignedActorBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on ConnectActor {\n    employee {\n      __typename\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n}\n\nfragment SignedActorText_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        id\n      }\n      user {\n        name\n        email\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      name\n      id\n    }\n    identifyingName\n  }\n  ... on ConnectActor {\n    __typename\n    identifyingName\n    employee {\n      name\n      id\n    }\n  }\n}\n\nfragment SignedActor_actor on Actor {\n  __isActor: __typename\n  ...Avatar_actor\n  ...SignedActorText_actor\n  ...SignedActorBadge_actor\n}\n\nfragment SingleTaskInProgressCheck_taskExecutionCheck on TaskExecutionCheck {\n  ...taskExecutionListCheckTaskExecutions\n  checkValue\n  updatedAt\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment TextControl_widgetNotePage on WidgetNotePage {\n  id\n  fontSize\n  fontStyle\n  backgroundColor\n  image {\n    __typename\n    id\n  }\n  ...useToggleFontColor_page\n  ...useNoteWidgetStyleText_widgetNotePage\n}\n\nfragment Tile_kpiTile on WidgetKPITile {\n  title\n  subtitle\n  value\n  unit\n  trends {\n    change\n    label\n    compareValue\n    type\n  }\n  graph {\n    __typename\n    label\n    ... on WidgetKPITileGraphBar {\n      __typename\n      ...Tile_kpiTileGraphBar\n    }\n    ... on WidgetKPITileGraphSlider {\n      __typename\n      ...Tile_kpiTileGraphSlider\n    }\n    ... on WidgetKPITileGraphRegions {\n      __typename\n      ...Tile_kpiTileGraphRegions\n    }\n    ... on WidgetKPITileGraphGauge {\n      __typename\n      ...Tile_kpiTileGraphGauge\n    }\n  }\n}\n\nfragment Tile_kpiTileGraphBar on WidgetKPITileGraphBar {\n  parts\n}\n\nfragment Tile_kpiTileGraphGauge on WidgetKPITileGraphGauge {\n  gaugeParts {\n    color\n    value\n    mode\n  }\n  indicators {\n    type\n    value\n  }\n}\n\nfragment Tile_kpiTileGraphRegions on WidgetKPITileGraphRegions {\n  negative\n  positive\n}\n\nfragment Tile_kpiTileGraphSlider on WidgetKPITileGraphSlider {\n  parts\n}\n\nfragment ToolbarButtonAssignees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ToolbarButtonAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment WidgetCalendarEvent_teamScheduleOneOffEvent on TeamScheduleOneOffEvent {\n  id\n  startAtFormatted\n  startAt\n  endAtFormatted\n  description\n  title\n}\n\nfragment WidgetCalendarOverview_widget on WidgetCalendarOverview {\n  id\n  title\n}\n\nfragment WidgetCalendar_widgetCalendar on WidgetCalendar {\n  id\n  overviewSize\n  events {\n    id\n    ...WidgetCalendarEvent_teamScheduleOneOffEvent\n  }\n}\n\nfragment WidgetEmployeeLeaveItem_item on WidgetEmployeeLeaveItem {\n  id\n  employee {\n    id\n    name\n    image {\n      __typename\n      ...ImagePublicOrPrivate_image\n      ... on Image {\n        id\n      }\n    }\n  }\n  shifts {\n    id\n    startAt\n    endAt\n    formattedStartAtTime\n    formattedEndAtTime\n    leaveReason {\n      id\n      leaveReason\n      leaveCode\n    }\n  }\n}\n\nfragment WidgetEmployeeLeave_widgetEmployeeLeave on WidgetEmployeeLeave {\n  id\n  title\n  employeesOnLeave {\n    id\n    ...WidgetEmployeeLeaveItem_item\n  }\n}\n\nfragment WidgetEmployeeRoleOverviewContent_widget on WidgetEmployeeRoleOverview {\n  roleContent: content {\n    __typename\n    ... on WidgetEmployeeRoleOverviewContentListMedium {\n      subscriptionKey\n      roles {\n        id\n        ...WidgetEmployeeRoleOverviewListItem_role\n      }\n      id\n    }\n  }\n}\n\nfragment WidgetEmployeeRoleOverviewListItem_role on EmployeeRole {\n  id\n  name\n  team {\n    id\n    name\n    color\n  }\n  employees {\n    id\n    name\n    ...Avatar_employee\n  }\n}\n\nfragment WidgetEmployeeRoleOverview_widget on WidgetEmployeeRoleOverview {\n  id\n  title\n  ...WidgetEmployeeRoleOverviewContent_widget\n}\n\nfragment WidgetEmployeeScheduleIcon_widgetEmployeeSchedule on WidgetEmployeeSchedule {\n  provider\n}\n\nfragment WidgetEmployeeScheduleShiftBar on EmployeeShift {\n  status\n  formattedStartAtTime\n  formattedEndAtTime\n  durationSeconds\n  startAtSecondsFromMidnight\n  scheduleType {\n    title\n    color\n    id\n  }\n  secondaryScheduleType {\n    title\n    color\n    id\n  }\n}\n\nfragment WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee on Employee {\n  name\n}\n\nfragment WidgetEmployeeScheduleShiftsEmployee_employee on Employee {\n  id\n  ...WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee\n  shifts {\n    id\n    ...WidgetEmployeeScheduleShiftBar\n  }\n}\n\nfragment WidgetEmployeeSchedule_widgetEmployeeSchedule on WidgetEmployeeSchedule {\n  id\n  overviewSize\n  teams {\n    id\n  }\n  ...WidgetEmployeeScheduleIcon_widgetEmployeeSchedule\n  employeesWithShifts {\n    id\n    shifts {\n      status\n      id\n    }\n    ...WidgetEmployeeScheduleShiftsEmployee_employee\n  }\n}\n\nfragment WidgetFileDynamic_widgetFile on WidgetFile {\n  ...WidgetFileStatic_widgetFile\n  id\n  title\n  files {\n    pages {\n      id\n      ...WidgetFilePage_page\n    }\n    file {\n      id\n      status\n      ...WidgetFilePageProcessing_file\n      name\n    }\n  }\n}\n\nfragment WidgetFilePageProcessing_file on File {\n  status\n}\n\nfragment WidgetFilePage_page on FilePage {\n  id\n  image {\n    id\n    ...Image_image\n  }\n}\n\nfragment WidgetFileStatic_widgetFile on WidgetFile {\n  id\n  title\n  slideshowDuration\n  files {\n    pages {\n      id\n      ...WidgetFilePage_page\n    }\n    file {\n      id\n      status\n      ...WidgetFilePageProcessing_file\n      name\n    }\n  }\n}\n\nfragment WidgetFile_widgetFile on WidgetFile {\n  id\n  files {\n    file {\n      id\n      status\n    }\n  }\n  ...WidgetFileStatic_widgetFile\n  ...WidgetFileDynamic_widgetFile\n}\n\nfragment WidgetIntegrationFlourishPraiseLeaderboardItem on WidgetIntegrationFlourishPraiseLeaderboardItem {\n  id\n  praise\n  title\n}\n\nfragment WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise on WidgetIntegrationFlourishPraise {\n  id\n  overviewSize\n  flourishTeams {\n    id\n    ...WidgetIntegrationFlourishPraiseLeaderboardItem\n  }\n}\n\nfragment WidgetIntegrationPushAppy_widgetIntegrationPushAppy on WidgetIntegrationPushAppy {\n  id\n  title\n  overviewSize\n  leaderboard {\n    id\n    title\n    goal\n    progress\n    total\n  }\n}\n\nfragment WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  acceptedTimeAverageInMs\n}\n\nfragment WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  unanswered\n  rejected\n  total\n}\n\nfragment WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  ...WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary\n}\n\nfragment WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  acceptedTimeAverageInMs\n}\n\nfragment WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  total\n}\n\nfragment WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  unanswered\n  rejected\n}\n\nfragment WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  total\n}\n\nfragment WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  ...WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary\n}\n\nfragment WidgetIntegrationTurnpike_widgetIntegrationTurnpike on WidgetIntegrationTurnpike {\n  id\n  turnpikeSize\n  integration {\n    summary {\n      ...WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary\n      ...WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary\n    }\n    id\n  }\n}\n\nfragment WidgetKPI_widgetKPI on WidgetKPI {\n  id\n  title\n  dataSource\n  tiles {\n    ...Tile_kpiTile\n  }\n}\n\nfragment WidgetList_listItemInfo on WidgetListItemInfo {\n  __isWidgetListItemInfo: __typename\n  __typename\n  ... on StoreZonedDate {\n    storeFormattedDate(style: DEFAULT)\n  }\n  ... on WidgetListItemInfoText {\n    text\n    italic\n  }\n}\n\nfragment WidgetList_widgetList on WidgetList {\n  id\n  title\n  dataSource\n  sections {\n    title\n    items {\n      title\n      rightText\n      rightTextSuffix\n      info {\n        __typename\n        ...WidgetList_listItemInfo\n      }\n    }\n  }\n}\n\nfragment WidgetNewsfeedPost_widgetNewsfeedPost on WidgetNewsfeedPost {\n  title\n  body\n  images {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  date\n}\n\nfragment WidgetNewsfeed_widgetNewsfeed on WidgetNewsfeed {\n  title\n  newsfeed {\n    provider\n    id\n  }\n  ...NewsfeedNative_widgetNewsfeed\n  ...NewsfeedWeb_widgetNewsfeed\n}\n\nfragment WidgetNoteCameraMode_widgetNotePage on WidgetNotePage {\n  ...WidgetNoteText_page\n}\n\nfragment WidgetNotePageBackgroundSelector_widgetNotePage on WidgetNotePage {\n  id\n  backgroundColor\n  fontStyle\n  fontSize\n}\n\nfragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  image {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  imageScale\n  imageTranslateX\n  imageTranslateY\n  remoteImageURL\n  containImage\n}\n\nfragment WidgetNotePageImageMode_widgetNotePage on WidgetNotePage {\n  ...WidgetNoteText_page\n  id\n  fontColor\n  ...useToggleFontColor_page\n  ...useNoteWidgetStyleText_widgetNotePage\n}\n\nfragment WidgetNotePage_widgetNotePage on WidgetNotePage {\n  id\n  currentValue\n  version\n  ...useNoteWidgetStyleText_widgetNotePage\n  ...WidgetNotePageBackground_widgetNotePage\n}\n\nfragment WidgetNoteTextModeAccessoryView_page on WidgetNotePage {\n  id\n  ...PageSettingsLeft_page\n  ...PageSettings_page\n}\n\nfragment WidgetNoteTextModePage_widgetNotePage on WidgetNotePage {\n  currentValue\n  updatedByActorId\n  id\n  ...WidgetNotePageBackground_widgetNotePage\n  ...useNoteWidgetStyleText_widgetNotePage\n}\n\nfragment WidgetNoteText_page on WidgetNotePage {\n  currentValue\n  ...useNoteWidgetStyleText_widgetNotePage\n}\n\nfragment WidgetNote_widgetNote on WidgetNote {\n  id\n  note {\n    editingMode\n    isOrgNote\n    pages {\n      id\n    }\n    ...NoteWeb_note\n    ...NoteNative_note\n    id\n  }\n}\n\nfragment WidgetRoutineOverview_widgetRoutineOverview on WidgetRoutineOverview {\n  id\n  title\n}\n\nfragment WidgetRoutinePositivePercentageRoutineItem_routine on Routine {\n  id\n  title\n  ownerTeam {\n    name\n    id\n  }\n  lastCompletedOccasion {\n    endAt\n    percentage\n    id\n  }\n}\n\nfragment WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage on WidgetRoutinePositivePercentage {\n  id\n  title\n  routines {\n    id\n    ...WidgetRoutinePositivePercentageRoutineItem_routine\n  }\n}\n\nfragment WidgetSignalOverviewContentMediumPaginated on WidgetSignalOverview {\n  teams {\n    id\n  }\n  signalContent: content {\n    __typename\n    ... on WidgetSignalOverviewContentMedium {\n      signals(first: 20) {\n        edges {\n          node {\n            id\n            ...SignalOverviewListItemMedium_Signal\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n  id\n}\n\nfragment WidgetSignalOverview_widget on WidgetSignalOverview {\n  id\n  title\n  teams {\n    id\n  }\n  ...WidgetSignalOverviewContentMediumPaginated\n}\n\nfragment WidgetSpace_widgetSpace on WidgetSpace {\n  id\n  title\n  subWidgets {\n    __typename\n    ... on WidgetFile {\n      id\n      height\n      width\n      overviewSize\n      positionX\n      positionY\n      ...WidgetFile_widgetFile\n      __typename\n    }\n    ... on WidgetNote {\n      id\n      height\n      width\n      noteSize\n      positionX\n      positionY\n      ...WidgetNote_widgetNote\n      __typename\n    }\n    id\n  }\n}\n\nfragment WidgetTable_cell on WidgetTableCell {\n  value\n  changeType\n}\n\nfragment WidgetTable_row on WidgetTableRow {\n  cells {\n    ...WidgetTable_cell\n  }\n}\n\nfragment WidgetTable_section on WidgetTableSection {\n  headerRow {\n    ...WidgetTable_row\n  }\n  rows {\n    cells {\n      value\n      sortValue\n    }\n    ...WidgetTable_row\n  }\n}\n\nfragment WidgetTable_sheet on WidgetTableSheet {\n  title\n  columns {\n    label\n  }\n  sections {\n    ...WidgetTable_section\n  }\n}\n\nfragment WidgetTable_table on WidgetTable {\n  id\n  title\n  dataSource\n  sheets {\n    title\n    ...WidgetTable_sheet\n  }\n}\n\nfragment WidgetTaskCollection_widgetTaskCollection on WidgetTaskCollection {\n  id\n  title\n  taskSections {\n    __typename\n    id\n    section {\n      id\n      title\n    }\n    task {\n      __typename\n      id\n      title\n      routine {\n        id\n        title\n      }\n    }\n    inProgressTaskExecution {\n      __typename\n      ...WidgetTaskMultipleRenderTask_taskExecution\n      id\n    }\n  }\n}\n\nfragment WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck on TaskExecutionCheck {\n  checkValue\n}\n\nfragment WidgetTaskMultipleRenderTaskContent_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  ... on TaskExecutionCheck {\n    __typename\n    ...WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck\n  }\n  ... on TaskExecutionNumber {\n    __typename\n    ...WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber\n  }\n  ... on TaskExecutionText {\n    __typename\n    ...WidgetTaskMultipleRenderTaskText_taskExecutionText\n  }\n}\n\nfragment WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber on TaskExecutionNumber {\n  numberValue\n  formattedNumberValue\n}\n\nfragment WidgetTaskMultipleRenderTaskText_taskExecutionText on TaskExecutionText {\n  textValue\n}\n\nfragment WidgetTaskMultipleRenderTask_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  ...WidgetTaskMultipleRenderTaskContent_taskExecution\n  routineOccasion {\n    endAt\n    id\n  }\n}\n\nfragment WidgetTaskSingleCheckSmallInProgress_taskExecutions on TaskExecutionCheck {\n  checkValue\n  ...taskExecutionListCombineCheckTaskExecutions\n}\n\nfragment WidgetTaskSingleCheck_taskCheck on TaskCheck {\n  id\n  title\n  routine {\n    id\n    title\n  }\n  occasions(first: 8) {\n    edges {\n      node {\n        id\n        ...WidgetTaskSingleCheck_taskCheckOccasion\n        taskExecutions {\n          id\n          checkValue\n          sectionId\n          ...WidgetTaskSingleCheckSmallInProgress_taskExecutions\n          ...SingleTaskInProgressCheck_taskExecutionCheck\n        }\n        occasion {\n          id\n          startAt\n          endAt\n          sequenceNumber\n        }\n      }\n    }\n  }\n}\n\nfragment WidgetTaskSingleCheck_taskCheckOccasion on TaskCheckOccasion {\n  id\n  occasion {\n    startAt\n    endAt\n    id\n  }\n  taskExecutions {\n    sectionId\n    checkValue\n    id\n  }\n}\n\nfragment WidgetTaskSingleNumberOccasionPage_taskNumber on TaskNumber {\n  id\n  unit\n  title\n  routine {\n    id\n    title\n    type\n    schedule {\n      rules {\n        freq\n      }\n    }\n  }\n  occasions(first: 8) {\n    edges {\n      node {\n        id\n        occasion {\n          id\n          startAt\n          endAt\n          sequenceNumber\n        }\n        taskExecutions {\n          numberValue\n          sectionId\n          goals {\n            lessThan\n            greaterThan\n          }\n          ...useGroupNumberTaskExecution_taskExecutionNumber\n          updatedAt\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment WidgetTaskSingle_widgetTaskSingle on WidgetTaskSingle {\n  id\n  title\n  grouping\n  taskSingleSize\n  ...useWidgetTaskSingleSections_widgetTaskSingle\n  activeSectionVersions {\n    section {\n      id\n    }\n    id\n  }\n  task {\n    id\n    routine {\n      id\n      type\n      title\n    }\n    __typename\n    ... on TaskNumber {\n      ...WidgetTaskSingleNumberOccasionPage_taskNumber\n    }\n    ... on TaskCheck {\n      ...WidgetTaskSingleCheck_taskCheck\n    }\n  }\n}\n\nfragment WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily on WidgetTeamScheduleContentDaily {\n  dailyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      ...useNowIndexes_teamScheduleEventOccasion\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleContentList_teamSchedule on TeamSchedule {\n  id\n  label\n  freq\n  events(includeInlineRoutines: true) {\n    __typename\n    id\n    startAt\n    ... on RoutineOccasion {\n      routine {\n        id\n        description\n        descriptionImages {\n          id\n        }\n      }\n    }\n    ... on TeamScheduleInlineRoutineOccasion {\n      taskExecution {\n        routine {\n          id\n          description\n          descriptionImages {\n            id\n          }\n        }\n        id\n      }\n    }\n    ...useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion\n    ...WidgetTeamScheduleListItem_item\n  }\n}\n\nfragment WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly on WidgetTeamScheduleContentMonthly {\n  monthlyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    ...WidgetTeamScheduleContentStatus_teamSchedule\n    id\n  }\n}\n\nfragment WidgetTeamScheduleContentSectionHeader_teamSchedule on TeamSchedule {\n  id\n  freq\n  label\n  ...WidgetTeamScheduleContentStatus_teamSchedule\n}\n\nfragment WidgetTeamScheduleContentStatus_teamSchedule on TeamSchedule {\n  events(includeInlineRoutines: true) {\n    __typename\n    id\n    ... on RoutineOccasion {\n      __typename\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      ...WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion\n    }\n    ... on TeamScheduleInlineRoutineOccasion {\n      __typename\n      taskExecution {\n        routineOccasion {\n          status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n          __typename\n          ...WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary on WidgetTeamScheduleContentSummary {\n  dailyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n      ...useNowIndexes_teamScheduleEventOccasion\n    }\n  }\n  weeklyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n  }\n  monthlyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n  }\n}\n\nfragment WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly on WidgetTeamScheduleContentWeekly {\n  weeklyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    id\n  }\n}\n\nfragment WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion on TeamScheduleInlineRoutineOccasion {\n  id\n  taskExecution {\n    id\n    task {\n      id\n    }\n    sectionId\n    routineOccasion {\n      id\n      store {\n        myRole\n        id\n      }\n      sequenceNumber\n      ...WidgetTeamScheduleRoutineListItemContent_RoutineOccasion\n      ...WidgetTeamScheduleRoutineIssueIndicator_routineOccasion\n      ...RoutineOccasionStatusCircleInline_RoutineOccasion\n    }\n    routine {\n      id\n      ...WidgetTeamScheduleRoutineListItemContent_Routine\n    }\n    checkValue\n  }\n}\n\nfragment WidgetTeamScheduleListItem_item on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  ... on TeamScheduleInlineRoutineOccasion {\n    id\n    startAt\n    taskExecution {\n      routineOccasion {\n        deadlineAt\n        sequenceNumber\n        id\n      }\n      routine {\n        id\n      }\n      id\n    }\n    __typename\n    ...WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion\n  }\n  ... on RoutineOccasion {\n    id\n    __typename\n    startAt\n    deadlineAt\n    sequenceNumber\n    routine {\n      id\n    }\n    ...WidgetTeamScheduleRoutineOccasionListItem_item\n  }\n}\n\nfragment WidgetTeamScheduleRoutineIssueIndicator_routineOccasion on RoutineOccasion {\n  issueCount\n}\n\nfragment WidgetTeamScheduleRoutineListItemContent_Routine on Routine {\n  id\n  description\n  title\n  isOrg\n  orgIconUri\n  descriptionImages {\n    size(minHeight: 120, minWidth: 120) {\n      url\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleRoutineListItemContent_RoutineOccasion on RoutineOccasion {\n  startAt\n  deadlineAt\n  assigned {\n    id\n    employee {\n      id\n      name\n      isLinkedToViewer\n      ...Avatar_employee\n      ...ToolbarButtonAssignees_employees\n      ...ListItemAssignees_employees\n    }\n  }\n  assignedRoles {\n    role {\n      id\n      name\n      isLinkedToViewer\n      employeeIds\n      ...ToolbarButtonAssignees_roles\n      ...ListItemAssignees_roles\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleRoutineOccasionListItem_item on RoutineOccasion {\n  id\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n  ...WidgetTeamScheduleRoutineIssueIndicator_routineOccasion\n  ...WidgetTeamScheduleRoutineListItemContent_RoutineOccasion\n  totalTaskExecutionCount\n  sequenceNumber\n  routine {\n    id\n    ...WidgetTeamScheduleRoutineListItemContent_Routine\n  }\n}\n\nfragment WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  totalTaskExecutionCount\n}\n\nfragment WidgetTeamSchedule_widget on WidgetTeamSchedule {\n  id\n  overviewSize\n  title\n  teams {\n    id\n    color\n  }\n  content {\n    __typename\n    ... on WidgetTeamScheduleContentDaily {\n      ...WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily\n    }\n    ... on WidgetTeamScheduleContentWeekly {\n      ...WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly\n    }\n    ... on WidgetTeamScheduleContentMonthly {\n      ...WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly\n    }\n    ... on WidgetTeamScheduleContentSummary {\n      ...WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary\n    }\n  }\n}\n\nfragment WidgetTodoOverview_widget on WidgetTodoOverview {\n  id\n  title\n  category {\n    store {\n      myRole\n      id\n    }\n    id\n    title\n    integration\n  }\n  teams {\n    id\n  }\n}\n\nfragment WidgetTodoSummary_widgetTodoSummary on WidgetTodoSummary {\n  id\n  title\n  category {\n    id\n    title\n  }\n  teams {\n    id\n    notResolvedCount\n    team {\n      id\n      name\n      color\n      icon\n    }\n  }\n}\n\nfragment WidgetWeatherBackground_WidgetWeather on WidgetWeather {\n  currentOccasion {\n    condition\n  }\n}\n\nfragment WidgetWeatherConditionIcon_WeatherOccasion on WidgetWeatherOccasion {\n  condition\n}\n\nfragment WidgetWeatherCurrentPane_weatherOccasion on WidgetWeatherOccasion {\n  temp\n  description\n}\n\nfragment WidgetWeatherDatePaneListItem_WeatherOccasion on WidgetWeatherOccasion {\n  date\n  condition\n  lowTemp\n  highTemp\n  ...WidgetWeatherConditionIcon_WeatherOccasion\n}\n\nfragment WidgetWeather_widget on WidgetWeather {\n  id\n  title\n  size\n  ...WidgetWeatherBackground_WidgetWeather\n  currentOccasion {\n    ...WidgetWeatherCurrentPane_weatherOccasion\n  }\n  occasions {\n    date\n    ...WidgetWeatherDatePaneListItem_WeatherOccasion\n  }\n}\n\nfragment taskExecutionListCheckTaskExecutions on TaskExecutionCheck {\n  id\n  sectionId\n  checkValue\n}\n\nfragment taskExecutionListCombineCheckTaskExecutions on TaskExecutionCheck {\n  checkValue\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n\nfragment useGroupNumberTaskExecution_taskExecutionNumber on TaskExecutionNumber {\n  id\n  sectionId\n  numberValue\n  updatedAt\n  goals {\n    lessThan\n    greaterThan\n  }\n}\n\nfragment useNoteWidgetStyleText_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  fontSize\n  fontStyle\n  fontColor\n  image {\n    id\n  }\n}\n\nfragment useNowIndexes_teamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  startAt\n}\n\nfragment useToggleFontColor_page on WidgetNotePage {\n  id\n  fontColor\n  ...useNoteWidgetStyleText_widgetNotePage\n}\n\nfragment useWidgetTaskSingleSections_widgetTaskSingle on WidgetTaskSingle {\n  activeSectionVersions {\n    id\n    title\n    ordinal\n    section {\n      id\n      assignedTeam {\n        id\n        name\n        color\n        icon\n      }\n    }\n  }\n}\n\nfragment useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  id\n  ... on TeamScheduleInlineRoutineOccasion {\n    taskExecution {\n      routine {\n        id\n      }\n      id\n    }\n  }\n  ... on RoutineOccasion {\n    routine {\n      id\n    }\n  }\n}\n\nfragment useWidgetToPos_widget on Widget {\n  __isWidget: __typename\n  id\n  positionX\n  positionY\n  ... on WidgetOverview {\n    __isWidgetOverview: __typename\n    overviewSize\n  }\n  ... on WidgetNote {\n    noteSize\n  }\n  ... on WidgetTaskSingle {\n    taskSingleSize\n  }\n  ... on WidgetWeather {\n    size\n  }\n  ... on WidgetIntegrationTurnpike {\n    turnpikeSize\n  }\n  ... on WidgetSpace {\n    subWidgets {\n      __typename\n      id\n      positionX\n      positionY\n      height\n    }\n  }\n  __typename\n}\n\nfragment widgetSettingsAvailable_widget on Widget {\n  __isWidget: __typename\n  id\n  __typename\n  ... on WidgetNote {\n    editingMode\n  }\n}\n"
  }
};
})();

(node as any).hash = "10736f8ed8c01ac55b39002691778133";

export default node;
